import { render, staticRenderFns } from "./ItemNavbarUsuario.vue?vue&type=template&id=f745ccbc&scoped=true"
import script from "./ItemNavbarUsuario.vue?vue&type=script&lang=js"
export * from "./ItemNavbarUsuario.vue?vue&type=script&lang=js"
import style0 from "./ItemNavbarUsuario.vue?vue&type=style&index=0&id=f745ccbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f745ccbc",
  null
  
)

export default component.exports